import React from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import TermsSection from "./TermsSection";

function Terms() {
    return (
        <div>
            <main>
                <Header />
                <TermsSection />
            </main>
            <Footer />
        </div>
    );
}

export default Terms;